module.exports = __webpack_public_path__ + "static/media/corner-navy.0b1ee6ba.svg";